import { TrackForm } from './TrackForm';
import { ScrollArea } from '@ais-ui/ui-core';
import React, { useEffect, useRef, useState } from 'react';
import { LabelForm } from './LabelForm';
import { TargetHoverLabelForm } from './TargetHoverLabelForm';
import { PortForm } from './PortForm';

export function MapForm() {
  const containerRef = useRef<HTMLDivElement>(null);
  const [calculatedHeight, setCalculatedHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      const viewportHeight = window.innerHeight;
      const containerTop =
        containerRef.current?.getBoundingClientRect().top || 0;
      const safetyMargin = 90; // Adjust this margin as needed
      const height = viewportHeight - containerTop - safetyMargin; // Subtracting an additional margin
      setCalculatedHeight(height);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);

    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div ref={containerRef} className="h-full">
      <ScrollArea style={{ height: `${calculatedHeight}px` }} className="pr-4">
        <div className="flex flex-col space-y-12">
          <PortForm></PortForm>
          <TrackForm></TrackForm>
          <TargetHoverLabelForm></TargetHoverLabelForm>
          <LabelForm></LabelForm>
        </div>
      </ScrollArea>
    </div>
  );
}
